import { FC } from 'react';

import { ICommonPopupsProps } from '../../components/PopupManager/PopupManager.types';
import { withPopupLayer } from '../../components/PopupManager/withPopupLayer';
import { PopupStore } from '../../stores/Popups/Popup/PopupStore';
import { PopupsStore } from '../../stores/Popups/PopupsStore';
import { IPopupOptions } from '../../stores/Popups/PopupsStore';

export const openPopup = <TParams, TResult = any>(
  Component: FC<ICommonPopupsProps<TParams, TResult>>,
  options?: IPopupOptions<TParams, TResult>
): PopupStore<TParams> => {
  return PopupsStore.openPopup<TParams>(withPopupLayer(Component), options);
};
